import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { usersApi } from './../../apis/users-api';
import { userKeys } from './../../keys/user-keys';

export interface UseUsersProps {
  page: number;
  q?: string;
  sort?: string;
}

export function useUsers(props: UseUsersProps) {
  const query = useQuery({
    queryKey: userKeys.list(props),
    queryFn: () =>
      usersApi.list({
        page: props.page,
        q: props.q,
        ordering: props.sort,
      }),
    placeholderData: keepPreviousData,
  });

  return query;
}

export default useUsers;
